
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CategorySuggestion,
  CategorySuggestionRequest,
  FamilyWithCategories,
} from '../models';
import {
    CategorySuggestionFromJSON,
    CategorySuggestionToJSON,
    CategorySuggestionRequestFromJSON,
    CategorySuggestionRequestToJSON,
    FamilyWithCategoriesFromJSON,
    FamilyWithCategoriesToJSON,
} from '../models';

export interface SuggestFamiliesAndCategoriesRequest {
    categorySuggestionRequest: CategorySuggestionRequest;
}

/**
 * 
 */
export class PublicFamiliesAndCategoriesApi extends runtime.BaseAPI {

    /**
     * Provides all families available with categories associated
          */
    async findAvailableFamiliesAndCategoriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FamilyWithCategories>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FamilyWithCategories>>({
            path: `/profile/public-api/families-and-categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FamilyWithCategoriesFromJSON);
        return response;
    }

    /**
     * Provides all families available with categories associated
          */
    async findAvailableFamiliesAndCategories(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FamilyWithCategories>> {
        const response = await this.findAvailableFamiliesAndCategoriesRaw(initOverrides);
        return response._data;
    }

    /**
     * Suggest families and categories according to the headline
          */
    async suggestFamiliesAndCategoriesRaw(requestParameters: SuggestFamiliesAndCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CategorySuggestion>>> {
        if (requestParameters['categorySuggestionRequest'] == null) {
            throw new runtime.RequiredError(
                'categorySuggestionRequest',
                'Required parameter "categorySuggestionRequest" was null or undefined when calling suggestFamiliesAndCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<Array<CategorySuggestion>>({
            path: `/profile/public-api/families-and-categories/suggestions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CategorySuggestionRequestToJSON(requestParameters['categorySuggestionRequest']),
        }, initOverrides);

        response._data=response._data?.map(CategorySuggestionFromJSON);
        return response;
    }

    /**
     * Suggest families and categories according to the headline
          */
    async suggestFamiliesAndCategories(requestParameters: SuggestFamiliesAndCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CategorySuggestion>> {
        const response = await this.suggestFamiliesAndCategoriesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
